define([
	"require",
	"jquery",
	"domReady",
	"wcs.utils",
	"md5",
	'shared.main.screen',
	"pubsub"
], function(require, $, domReady, Utils, md5, screenSize){

	// Grabs from local storage current layout (page first load)
	var currentLayout = JSON.parse(window.localStorage.getItem('currentLayout'));

	var _catNavEntriesWidths = [],
		_facetBarLocation = 0,
		_isHoverStateOn = false,
		_filterBarPostionSet = false,
		_scrollbarSize = 0,
		_currentColumn = 4, //Default is 4 columns
		_s7PresetToUse,
		_isGridLayoutImagePresetsEnabled =  WCS_CONFIG.get('grid::gridLayoutImagePresetsEnabled'),
		_s7Presets = VIEWPORTS ? VIEWPORTS.S7_PRESETS : {S7_PRESETS: {}},
		swatchesExpansionEnabled = WCS_CONFIG.get('grid::isProductGridSwatchesExpansionEnabled'),
		includeFullWidthSwatchSizeCalculation = WCS_CONFIG.get('grid::includeFullWidthSwatchSizeCalculation') || false,
		$filterBar = $('.facets-bar-js'),
        productGridCommonInlineQuickviewMobileEnabled = WCS_CONFIG.get('grid::productGridCommonInlineQuickviewMobileEnabled') || false,
        productGridCommonInlineQuickviewDesktopEnabled = WCS_CONFIG.get('grid::productGridCommonInlineQuickviewDesktopEnabled') || false,
		plpUpdatePriceOnSwatchesClick = WCS_CONFIG.get('grid::plpUpdatePriceOnSwatchesClick') || false,
		$appliedFacetsBar = $('.applied-facets-main-container-js'),
		maxSwatchCounts = {
			"small" : WCS_CONFIG.get('grid::productGridMaxSwatchesSmall'),
			"medium" : WCS_CONFIG.get('grid::productGridMaxSwatchesSmall'),
			"large" : WCS_CONFIG.get('grid::productGridMaxSwatchesLarge'),
			"xlarge" : WCS_CONFIG.get('grid::productGridMaxSwatchesXLarge') || WCS_CONFIG.get('grid::productGridMaxSwatchesLarge')
		},
		updateBlockBadgeEnabled = WCS_CONFIG.get('grid::updateBlockBadgeEnabled'),
		moreSwatchesAlignmentLogicEnabled = WCS_CONFIG.get('grid::moreSwatchesAlignmentLogicEnabled') || false;


	this.plpImageEventToken = $.pubsub('subscribe', 'PLP.IMAGE_EVENT', function (msg, event) {
		var $swatch = $(event.target).closest('.swatch-js');

		if( $swatch.data('main-image') ) {
			updateProductBlock($swatch);
		} else {
			updateProductBlockImg($swatch);
		}
		//update price only if swatches selected is in PLP to avoid double ajax call (this event is called also from STL) and config enabled
		if ( $swatch.parents('.product-listing-js').length > 0 && plpUpdatePriceOnSwatchesClick ) {
			updateItemPriceOnColorChange($swatch)
		}

		if ($('.quickshop-button-container').length > 0) {
			updateQuickViewURL(event);
		}
	});

	/* This function toggle the docking filter bar on and off based on
	*  the location of the scrolling bar. */
	function _toggleDockingBehavior (){

		$(window).on("scroll", function() {

			var offsetTop = 0,
	        	offsetLeft = 0;

	        if ($filterBar.length>0) {
	        	offsetTop = $filterBar.offset().top;
	        	offsetLeft = $filterBar.offset().left;
	        }

            if (_facetBarLocation <= 0){
            	_facetBarLocation = offsetTop;
            }
            if (($(window).scrollTop() >= _facetBarLocation) && (_filterBarPostionSet === false)) {

            	dockFilterBar(offsetLeft);

            } else if(($(window).scrollTop() <= _facetBarLocation) && (_filterBarPostionSet === true)){

				unDockFilterBar();

            }
        });
	}

	function dockFilterBar(offsetLeft){
    	_filterBarPostionSet = true;
        $filterBar.addClass('docked').css("left",offsetLeft);
        $appliedFacetsBar.addClass('docked').css("left",offsetLeft);
	}

	function unDockFilterBar(){
        _filterBarPostionSet = false;
        $filterBar.removeClass('docked').css("left","");
        $appliedFacetsBar.removeClass('docked').css("left","");
        _facetBarLocation = 0;
	}

	//This function toggles the extra facets on a filter group
	function toggleFacets ($filterGroup){
		var $this = $filterGroup.find('.filter-options'),
			$filterContainer = $filterGroup.find('.filter-options'),
			$hiddenFilters = $filterContainer.find('.hide-for-more'),
			$hiddenContainer = $filterContainer.find('.show-hidden-filters');

		if($hiddenFilters.length > 0){
			if($hiddenContainer.length === 0){
				$filterContainer.append('<ul class="show-hidden-filters"></ul>');
				$hiddenContainer = $filterContainer.find('.show-hidden-filters');
			}
			$hiddenFilters.removeClass('hide-for-more');
			$hiddenContainer.append($hiddenFilters);
			$filterContainer.remove('.hide-for-more');
		}
		$hiddenContainer.toggle('fast');
		$hiddenContainer.toggleClass('expanded').promise().done(function(){
			if($('.plp-sticky-sidebar').length > 0) {
				$.pubsub('publish','sticky-sidebar-facet-expanded');
			}
		});
	}

	/* This function calculates the width for each category on
	 * the navigation bar based on the number of categories present.
	 * The width is set in percentage so that it works with RWD.*/
	function _calcNavEntryWidthOnBar(){
		var $catNavBar = $('.nav-bar-js');
		if (screenSize.size() !== 'small'){
			$catNavBar.each(function (index){
				var $thisCatNavBar = $(this),
					$catNavEntries = $thisCatNavBar.find('.nav-option-js');
				if (_catNavEntriesWidths.length){
					$catNavEntries.css('width', _catNavEntriesWidths[index] + '%');
				}
				else{
					var catNavBarWidth = $thisCatNavBar.width(),
						catNavWidth = catNavBarWidth / $catNavEntries.length,
						catNavWidthPercentage = (100 * catNavWidth) / catNavBarWidth;
					$catNavEntries.css('width', catNavWidthPercentage + '%');
					_catNavEntriesWidths[index] = catNavWidthPercentage;
				}
			});
		}
		else{
			$catNavBar.each(function (){
				$(this).find('.nav-option-js').removeAttr('style');
			});
		}
	}

	//this function closes any expanded drop downs before expanding a new one.
	function _collapsedExpandedCustomDropDowns (closeAll){
		var $expandedDropDowns = $('.dd-select-js').not('.collapsed'),
			$indicators = null;
		closeAll = closeAll || false;

		if (!closeAll){
			$expandedDropDowns = $expandedDropDowns.not('.dd-select-parent-js');
		}
		hideFacetBG();
		$indicators = $expandedDropDowns.find('.indicator-js');
		$indicators.each(function (){
			var $this = $(this),
				selectedClass = $this.attr('data-selected-class');

			if (selectedClass){
				$this.removeClass(selectedClass);
			}

			$this.addClass ('icon-arrow-down-indicator-open').removeClass ('icon-arrow-up-indicator-open');
		});

		$expandedDropDowns.addClass ('collapsed').removeClass('selected');
	}

	/* This function displays the facet full width background if a facet
	 * dropdown is expanded.*/
	function displayFacetBG($dropDownNav){
		var $dropDownContainer = $dropDownNav.find('.dd-container-js'),
			height = $dropDownContainer.outerHeight();

		if ($dropDownNav.hasClass('filter-group-btn-js') && (screenSize.size() !== 'small' && screenSize.size() !== 'medium')){
			$('.facets-dropdown-bg-js').css('height', height + 'px').removeClass('hidden');
		}
	}

	/* This function hides the facet full width background when facets are
	 * collapsed. */
	function hideFacetBG(){
		$('.facets-dropdown-bg-js').addClass('hidden');
	}

	//This function toggles any custom dropdowns such as category, facets, and sort.
	/*
	 * Paramenters: $dropDowns is a single or a collection of dropdowns
	 * 	   Returns: no return*/
	function toggleCustomDropDown ($dropDowns){
		$dropDowns.each(function(){
			var $dropDownNav = $(this),
				$indicator = $($dropDownNav.find('.indicator-js').eq(0)),
				selectedClass = $indicator.attr('data-selected-class');

			if ($dropDownNav.hasClass ('collapsed')){
				_collapsedExpandedCustomDropDowns(!$dropDownNav.hasClass ('dd-select-parent-js') && $($dropDownNav.parents ('.dd-select-parent-js').eq(0)).length < 1);
				$dropDownNav.removeClass ('collapsed').addClass('selected');
				displayFacetBG($dropDownNav);

				if (selectedClass && ((screenSize.size() !== 'small' && screenSize.size() !== 'medium') || $indicator.hasClass('sort-by-indicator-js'))){
					$indicator.removeClass ('icon-arrow-down-indicator-open').addClass (selectedClass);
				}
				else{
					$indicator.removeClass ('icon-arrow-down-indicator-open').addClass ('icon-arrow-up-indicator-open');
				}
			}
			else{
				$dropDownNav.addClass ('collapsed').removeClass('selected');
				hideFacetBG();

				if (selectedClass && ((screenSize.size() !== 'small' && screenSize.size() !== 'medium') || $indicator.hasClass('sort-by-indicator-js'))){
					$indicator.addClass ('icon-arrow-down-indicator-open').removeClass (selectedClass);
				}
				else{
					$indicator.addClass ('icon-arrow-down-indicator-open').removeClass ('icon-arrow-up-indicator-open');
				}
			}
		});
	}

	//this function controls the toggling of the arrows style based on the viewport width
	function _onResizeAdjustSelectedDropDownArrow (){
		var $dropDowns = $('.dd-select-js', '.dd-select-parent-js'),
			$dropDownNav = $dropDowns.not ('.collapsed'),
			$indicator = $($dropDownNav.find('.indicator-js').eq(0)),
			selectedClass = $indicator.attr('data-selected-class');

		if (selectedClass){
			if ((screenSize.size() === 'small' || screenSize.size() === 'medium')){
				$indicator.addClass('icon-arrow-up-indicator-open').removeClass(selectedClass);
			}
		}
	}

	//This function adjust the width of the drop downs on the facets since they are styled
	//using absolute position.
	function _adjustDropDownFacetsWidth (){
		var $dropDownContainers = $('.dd-container-js', '.filters-container-js');
		if (screenSize.size() !== 'small' && screenSize.size() !== 'medium'){
			$('.facet-option-js.last').attr('data-last-class', 'last').removeClass('last');
			$dropDownContainers.css ('max-width', $('.facets-bar-js').width());
		}
		else{
			$('.facet-option-js[data-last-class]').addClass('last');
			$dropDownContainers.removeAttr ('style');
		}
	}

	//This function relocates the applied facets on mobile
	function _relocateAppliedFacetsOnMobile (){
		if (WCS_CONFIG.get("grid::gridTopBarEnabled") === true)
			return;

		var $selectedFacetsContainer = $('.breadcrumb-selected-facet-js');

		$selectedFacetsContainer.each(function(){
			var $this = $(this),
				$parent = $this.parent(),
				$mobileContainer = $('<div>').addClass('applied-facets-mobile-container product-list-search-top-js'),
				_tabletAndUpRelocationClass = $this.attr('data-tablet-up-relocation'),
				_mobileRelocationClass = $this.attr('data-mobile-relocation');

			if ( screenSize.size() === 'small' && $parent.hasClass('applied-facets-main-container-js')){
				if ($('.applied-facets-mobile-container').length < 1){
					$mobileContainer.append($this);
					$('.' + _mobileRelocationClass).after($mobileContainer);
				}
				else{
					$('.applied-facets-mobile-container').append($this);
				}
				$parent.removeClass('product-list-search-top-js');
			}
			else if (screenSize.size() !== 'small' && $parent.hasClass('applied-facets-mobile-container')){
				$('.' + _tabletAndUpRelocationClass).append($this).addClass('product-list-search-top-js');
				$parent.removeClass('product-list-search-top-js');
			}
		});
	}
	
	//update badge position if inlineQuickView is enabled and swatches are in new position
	function updateBadgePosition() {
		var $promoBadgeSelector = $('.product-block-promo-badge')
		if ( $promoBadgeSelector.length > 0 ) {
			var topAlignment = $('.product-block-pdp-url').outerHeight(true) -  $promoBadgeSelector.outerHeight(true);
			$promoBadgeSelector.css('top',topAlignment);
		}
	}

	//This function initializes see more swatches
	function initMoreSwatches (layout) {

		var $swatchContainer = $('.color-swatches-js'),
			maxSwatchesOnOneRow = _calcMaxSwatches ($swatchContainer),
			maxSwatchesWithShowMoreBtn = maxSwatchesOnOneRow - 1,
			swatchContainerData = $swatchContainer.data(),
			selectedLayout = layout || currentLayout,
			customSwatchesAmount = (maxSwatchCounts.large && maxSwatchCounts.small) || selectedLayout; // Checks if custom amount of swatches are being passed in

		// Logic when custom amount of swatches per grid view
		if (selectedLayout) {
			maxSwatchesOnOneRow = layout ? layout.visibleSwatches : currentLayout.visibleSwatches;
			maxSwatchesWithShowMoreBtn = maxSwatchesOnOneRow;
		}

		// Logic when custom amount of swatches are being passed in regardless of grid view
		if ((maxSwatchCounts.small && maxSwatchCounts.large) && !selectedLayout) {
			maxSwatchesOnOneRow = maxSwatchCounts[screenSize.size()] || maxSwatchesOnOneRow - 1 // if fall into default value remove the +X button as a swatch;
			maxSwatchesWithShowMoreBtn = maxSwatchesOnOneRow;
		}

		$swatchContainer.each (function (){
			var $this = $(this),
				hasShowMore = 'has-show-more',
				singleRow = 'single-row',
				hasDYO = $this.parent().find('.bl-design-your-own-container').length,
				$swatches = $this.find('.swatch-js'),
				$swatchesContainer = $this.find('.swatches-container'),
				totalSwatches = (hasDYO && swatchesExpansionEnabled) ? $swatches.length + 1 : $swatches.length,
				areSwatchesOnMultipleRows = totalSwatches > (customSwatchesAmount ? maxSwatchesOnOneRow : maxSwatchesWithShowMoreBtn), // Quick verification whether we need to include the +X button or not
				$moreBtnContainer = $this.find('.more-swatches')
				$moreBtn = $this.find('.swatch-counter-js'),
				$swatch = $($swatches.get(0)),
				swatchWidth = $swatch.outerWidth(true);

			// If swatches container is empty add class to hide it
			if (!totalSwatches) {
				$swatchesContainer.parent().addClass('hide');
			}

			// If product has DYO and swatches expansion are enabled then move it to swatches container
			if (hasDYO) {
				var $dyo = $this.parent().find('.bl-design-your-own-container');
				$dyo.parent().addClass('product-block-dyo');

				if (swatchesExpansionEnabled) {
					$dyo.addClass('product-block-color-swatch swatch');
					$dyo.appendTo($swatchesContainer);
				}
			}

			if (moreSwatchesAlignmentLogicEnabled) {
				var swatchesContainerWidth = $this.width(),
				swatchWidth = 30,
				swatchGap = 6,
				swatchMobileWidth = 30,
				swatchMobileGap = 8,
				elementsToFit;
				if( screenSize.size() === 'small') {
					elementsToFit = Math.floor(swatchesContainerWidth / (swatchMobileWidth + swatchMobileGap));
				} else {
					elementsToFit = Math.floor(swatchesContainerWidth / (swatchWidth + swatchGap));
				}
				if (totalSwatches > elementsToFit) {
					$moreBtn.text(totalSwatches - (elementsToFit -1));
					if(!$this.find('.swatch-count').length) {
						var $newDiv = $('<div class="swatch swatch-count"> </div>');
						$newDiv.append($moreBtnContainer);
						$swatchesContainer.children().eq(elementsToFit-1).before($newDiv);
					}
					$this.addClass(hasShowMore);
					$this.removeClass(singleRow);
				} else {
					$this.addClass(singleRow);
					$this.removeClass(hasShowMore);
				}
			} else {
				if (areSwatchesOnMultipleRows) {
					$this.removeClass(singleRow);
					$this.addClass(hasShowMore);
					if (swatchContainerData.colorSwatchLess && swatchContainerData.colorSwatchMore) {
						$moreBtn.text(swatchContainerData.colorSwatchMore);
					} else {
						$moreBtn.text(totalSwatches - (customSwatchesAmount ? maxSwatchesOnOneRow : maxSwatchesWithShowMoreBtn));
					}
				} else {
					$this.addClass(singleRow);
					$this.removeClass(hasShowMore);
				}
			}

			// Checks if there's a grid layout selected or custom swatches amount.
			// If so then we'll trigger this method to calculate the number of visible swatches
			// for that particular grid view and resize the container.
			if (customSwatchesAmount) $swatchesContainer.css('width', maxSwatchesWithShowMoreBtn * swatchWidth + 'px');
		});

		if (WCS_CONFIG.grid.productGridEnablePerformanceMarks) {
			performance.mark("Product Grid Swatches ready");
		}
	}

	// This function handles updating the PDP url to pass the corresponding selected color..
	function _updateColorClickThrough($selectedSwatch){
		if (WCS_CONFIG.get("grid::productGridColorClickThroughEnabled")){
	    	var $productTile = $selectedSwatch.parents('.product-block-js');
	    	var $productDetailLink = $productTile.find('.pdp-url-js');
	    	var $quickshopUrl = $productTile.find('.quickshop-js');
	    	var $productNameLink = $productTile.find('.name-js a');
	    	var variationIdParam = 'variationId';
	    	var variationCode = $selectedSwatch.attr('id');

	    	var quickshopUrl = $quickshopUrl.attr('data-ajax');
	    	quickshopUrl = Utils.setURLParam(quickshopUrl, variationIdParam, variationCode);
	    	$quickshopUrl.attr('data-ajax', quickshopUrl);

	    	var pdpUrl = $productDetailLink.attr('href');
	    	pdpUrl = Utils.setURLParam(pdpUrl, variationIdParam, variationCode);
	    	$productDetailLink.attr('href', pdpUrl);

	    	var productNameUrl = $productNameLink.attr('href');
	    	productNameUrl = Utils.setURLParam(productNameUrl, variationIdParam, variationCode);
	    	$productNameLink.attr('href', productNameUrl);

		}
    }

	function updateVariationId($quickShopBtn){
		var variationId = Utils.getURLParam($quickShopBtn.attr('data-ajax'), "variationId");
		$('body').attr('data-variation-id', variationId);

	}

	// This function updates the AJAX URL for the quickview with the selected variant
	var updateQuickViewURL = function(event) {

		var $swatch = $(event.target).closest('.swatch-js'),
			productVariationId = $swatch.data('variation'),
			$productBlock = $swatch.closest('.product-block-js'),
			$quickShopButton = $productBlock.find('.quickshop-button-container .quickshop-js'),
			ajaxURL = $quickShopButton.data('open-ajax');

		var newAjaxURL = Utils.setURLParam(ajaxURL, 'variationId', productVariationId);

		$quickShopButton.data('open-ajax', newAjaxURL);
	};

	var updateItemPriceOnColorChange = function($swatch) {
		$product = $swatch.closest('.product-block'),
		$colorSwatchContainer = $product.find('.color-swatches-js'),
		productId = $colorSwatchContainer.data('product-id'),
		colorAttributeId = $colorSwatchContainer.data('color-attr-id'),
		colorAttributeValue = $swatch.data('attribute-value'),
		storeId = null,
		langId = null,
		catalogId = $("meta[name='catalogId']").attr("content");

		if (productId != null && colorAttributeId != null) {
			require(['wcs.context'], function (ctx) {
				storeId = ctx.getStoreId();
				langId =  ctx.getLangId();
				queryParams = {
					productId: productId,
					storeId: storeId,
					langId: langId,
					catalogId: catalogId
				};
			
				$.ajax({
					url: ctx.getURLWithContextRoot('VFAjaxItemPricingView'),
					type: 'GET',
					data: queryParams,
				}).then(function(res) {
					require(['wcs.product-price-service'], function (priceService) {
						var $priceContainer = $swatch.parents('.product-block').find('.product-price'),
							priceItem = res.pricing[colorAttributeId][colorAttributeValue];
							if ( typeof priceItem != 'undefined') {
								priceService.loadPriceValues($priceContainer, priceItem);
							}
					});
				});
			});
		}
	};
	
	//This function is used for swapping the colors on product block
	var updateProductBlockImg = function ($swatch) {

		var $productBlock = $swatch.closest('.product-block-js').length > 0 ? $swatch.closest('.product-block-js') : $swatch.closest('.product'),
			partNumber = $productBlock.data('part-number').toString(),
			$prevSelectedSwatch = $swatch.parents('.color-swatches-js').find('.selected-js'),
			oldVariationCode = $prevSelectedSwatch.attr ('id'),
			variationCode = $swatch.attr('id'),
			swatchInfo = {
				productBlock : $productBlock,
				partNumber : partNumber,
				variationCode : variationCode,
				oldVariationCode : oldVariationCode,
				oldSelected : {
					swatch : $prevSelectedSwatch
				},
				newSelected : {
					swatch : $swatch,
					imgSet : [],
					url : []
				}
			},
			newImageSet = $swatch.data('s7-image-set-name'),
			oldImageSet = $productBlock.data('s7-image-set-name'),
			// Need a unique name so multiple JSONP callbacks don't collide
			// But also make it specific to the product so the response can be cached
			callback = 'cb_' + md5(newImageSet);

		$prevSelectedSwatch.removeClass ('selected-js selected');
		$swatch.addClass ('selected-js selected');

		// Update the product block image set so the rollover works correctly
		$productBlock.data('s7-image-set-name', newImageSet);

		// Get the first image in the image set and set it to the product block
		$.ajax({
			url: SCENE7.SERVER_URL + newImageSet + '?req=imageset,json',
			dataType: 'jsonp',
			jsonpCallback: callback,
			data: {
				handler: callback
			},
			cache: true
		}).done(function(data){
			var img,
				images = data.IMAGE_SET.split(',');
			if(images.length)
				img = images[0].split(';')[0];
			if(img) {
				$productBlock.find('.views-container-js .main-view-js').each(function (){

					var $this = $(this),
						$dataSrcset = $this.attr('data-pfsrcset'),
						$srcAttr = $this.attr('src'),
						hasDataSrcset = (((typeof $dataSrcset !== typeof undefined  && $dataSrcset !== false) || $dataSrcset === "" ) ? true : false), // for iOS fix
						hasSrcAttr = (((typeof $srcAttr !== typeof undefined  && $srcAttr !== false) || $srcAttr === "" ) ? true : false), // for i.e. fix
						url = SCENE7.SERVER_URL + img,
						s7Profile = $this.data('s7-profile');

					if(_isGridLayoutImagePresetsEnabled) {
						s7Profile = getS7PresetWithScreenSize();
					}

					if(s7Profile)
						url += '?$'+s7Profile+'$';

					if(hasSrcAttr){ // for i.e. fix
						$this.attr('src', url);
					}

					if(hasDataSrcset){
						$this.attr('data-pfsrcset', url); // for iOS fix
					} else {
						$this.attr('srcset', url);
					}

					swatchInfo.newSelected.imgSet.push(newImageSet);
					swatchInfo.newSelected.url.push(url);
					swatchInfo.newSelected.images = images;
				});

				$.pubsub('publish', 'PLP.SWATCH.CLICKED', swatchInfo);
			}
		}).fail(function (jqXHR, status, error) {
			if (DEBUG && console) console.log('$.updateProductBlockImg AJAX error : ', jqXHR, status, error);
		});

		_updateInlineQuickViewBlock($swatch);
		_updateColorClickThrough($swatch);
		if (updateBlockBadgeEnabled) {
			_updateBlockBadge($productBlock, $swatch);
		}
	};

	function updateProductBlock($trigger) {
		if($trigger.hasClass('selected-js')) {
			return false;
		}
		var $prevSelectedSwatch = $trigger.parents('.color-swatches-js').find('.selected-js');
		$prevSelectedSwatch.removeClass ('selected-js selected');
		$trigger.addClass ('selected-js selected');

		var $productBlock = $trigger.closest('.product-block-js');
		var triggerElData = $trigger.data();
		$productBlock.data('part-number', $trigger.data('part-number'));
		// Update the product block image set so the rollover works correctly
		$productBlock.data('s7-image-set-name', $trigger.data('s7-image-set-name'));

		_updateMainBlockImage($productBlock, $trigger);
		_updateBlockLinks($productBlock, $trigger);

		if (triggerElData.originalPrice && triggerElData.currentPrice) {
			var priceContainer = $trigger.parents('.product-block-info').find('.product-price');
			updateProductBlockPrice(priceContainer, triggerElData.originalPrice, triggerElData.currentPrice);
		}

		var partNumber = $productBlock.data('part-number').toString(),
			oldVariationCode = $prevSelectedSwatch.attr ('id'),
			variationCode = $trigger.attr('id'),
			swatchInfo = {
				productBlock : $productBlock,
				partNumber : partNumber,
				variationCode : variationCode,
				oldVariationCode : oldVariationCode,
				oldSelected : {
					swatch : $prevSelectedSwatch
				},
				newSelected : {
					swatch : $trigger,
					imgSet : [],
					url : []
				}
			};

		$.pubsub('publish', 'PLP.SWATCH.CLICKED', swatchInfo);

	}

	function updateProductBlockPrice(priceContainer, $originalPrice, $currentPrice) {
		if ($originalPrice && $currentPrice) {
			var delimiterRegexString = WCS_CONFIG.get('global::delimiterRegex') ? WCS_CONFIG.get('global::delimiterRegex') : '\\d+([\/.]\d+)?',
				delimiterRegex = new RegExp(delimiterRegexString, 'g');

			var originalValue = $originalPrice.match(delimiterRegex)[0],
				currentValue = $currentPrice.match(delimiterRegex),
				minValue = currentValue[0],
				maxValue = currentValue.length > 2 ? currentValue[2] : currentValue[1],
				priceLabel = priceContainer.find('.product-block-range-price, .product-block-offer-price, .product-block-original-price'),
				offerLabel = priceContainer.find('.current-price'),
				offerPercentLabel = priceContainer.find('p .current-price');

			if (originalValue === maxValue) {
				if (minValue === maxValue) {
					priceLabel.text($originalPrice);
				} else {
					priceLabel.text($currentPrice);
				}
				priceLabel.addClass('offer-price').removeClass('original-price'); // remove strikeout and add bold
				offerLabel.hide();
				offerPercentLabel.hide();
			} else {
				priceLabel.text($originalPrice);
				priceLabel.addClass('original-price').removeClass('offer-price');
				if (maxValue === minValue) {
					offerLabel.text($currentPrice.split("-")[0]);
					updateDiscountPercentage(originalValue, [minValue], offerPercentLabel, priceContainer);
				} else {
					offerLabel.text($currentPrice);
					updateDiscountPercentage(originalValue, currentValue, offerPercentLabel, priceContainer);
				}
				offerLabel.show();
				offerPercentLabel.show();
			}
		}
	}

	/**
	 * Returns the discount percent calculated using passed arguments
	 * @param {String} originalPrice - Actual price of the product, single value
	 * @param {String} currentValues - Discounted values of product (min and max)
	 * @param {Object} discountElement - Element where discount value will be updated
	 * @param {Object} priceContainer - Element where fixed text are stored
	 */
	function updateDiscountPercentage(originalPrice, currentValues, discountElement, priceContainer) {
		if (currentValues) {
			var discountRange = currentValues.length,
				discountPercentage = null;
			if (discountRange > 1) {
				discountPercentage = (100 - Math.round(((currentValues[1] * 100) / originalPrice))) || 0;
				discountPercentage += "%";
				discountPercentage += priceContainer.data("discountSeparator") || "";
			}
			discountPercentage += (100 - Math.round(((currentValues[0] * 100) / originalPrice))) || 0;
			discountPercentage += "%";
			discountPercentage += priceContainer.data("discountText") || "";
			discountElement.text(discountPercentage);
		}
	}

	function _updateInlineQuickViewBlock($swatchBlock, $trigger) {
		var variationIdParam = 'variationId',
			variationCode 	 = $swatchBlock.attr('id'),
			$productBlock	 = $swatchBlock.closest('.product-block'),
			$swatchTarget 	 = $('span').filter("[data-variation-id='" + variationCode +"']").parent(),
			$pdpDetailTarget = $productBlock.find('.product-detail-btn-js');

		// Trigger click on button swatch color.
		$swatchTarget.click();

		var quickshopUrl = $pdpDetailTarget.attr('href');
		quickshopUrl = Utils.setURLParam(quickshopUrl, variationIdParam, variationCode);
		$pdpDetailTarget.attr('href', quickshopUrl);
	}

	function _updateMainBlockImage($productBlock, $trigger) {
		$productBlock.find('.main-view-js, .views-container-js img').each(function (){
			var $this = $(this),
	    		$dataSrcset = $this.data('data-pfsrcset'),
	    		$srcAttr = $this.attr('src'),
	    		hasDataSrcset = (((typeof $dataSrcset !== typeof undefined  && $dataSrcset !== false) || $dataSrcset === "" ) ? true : false), // for iOS fix
	    		hasSrcAttr = (((typeof $srcAttr !== typeof undefined  && $srcAttr !== false) || $srcAttr === "" ) ? true : false); // for i.e. fix
			var currProfile = '$$' + $this.data('s7-profile') + '$$';

			var url = $trigger.data('main-image').replace(RegExp("\\$[^\\$]*\\$", 'g'), currProfile);
			if(hasSrcAttr){ // for i.e. fix
    			$this.attr('src', url);
    		}
    		if(hasDataSrcset){
    			$this.attr('data-pfsrcset', url); // for iOS fix
    		}else{
    			$this.attr('srcset', url);
    		}
		});
	}

	function _updateBlockLinks($productBlock, $trigger) {

		$productBlock.find('.pdp-url-js').attr('href', $trigger.data('product-url'));

		var $quickView  = $productBlock.find('.quickshop-js'),
			oldUrl 		= $quickView.attr('data-ajax');

		// if quickshop is disabled oldUrl will be undefined
		if(typeof oldUrl === 'undefined'){
			return;
		}

		$quickView.attr('data-ajax', oldUrl.replace(RegExp('productId=\\d+'), 'productId='+$trigger.data('product-id')));

	}

	function _updateBlockBadge($productBlock, $swatch) {
		var $swatchData = $swatch.data(),
		 	$blockPromoBadge = $productBlock.find('.product-block-promo-badge-image');
		var $adaptiveImage = $blockPromoBadge.find('source');
		var $image = $blockPromoBadge.find('img');
		if ($swatchData.badgesrc && $swatchData.badgeattrvalue) {
			$blockPromoBadge.attr({
			  src: $swatchData.badgesrc,
			  alt: $swatchData.badgeattrvalue
			});

			if( $adaptiveImage.length > 0 ){
				$adaptiveImage.attr({
					srcset: $swatchData.badgesrc,
				});
				$image.attr({
					src: $swatchData.badgesrc,
					srcset: $swatchData.badgesrc,
					alt: $swatchData.badgeattrvalue
				});
			}
		} else {
			$blockPromoBadge.attr({
			  src: '',
			  alt: '', 
			  srcset: ''
			});

			if( $adaptiveImage.length > 0 ){
				$adaptiveImage.attr({
					srcset: '',
				});
				$image.attr({
					src: '',
					alt: '',
					srcset: '',
				});
			}
		}
	}

	//This function is used to display more swatches when the user clicks on more button
	function toggleMoreSwatches($swatchContainer) {
		$swatchContainer.toggleClass('show-more');
			// when enabled multiple more swatch can we viewed on grid page.
			if (swatchesExpansionEnabled) {
				var swatchContainerData = $swatchContainer.data(),
					$moreBtn = $swatchContainer.find('.swatch-counter-js');
					$swatchContainer.toggleClass('swatches-expansion-enabled');

				if (swatchContainerData.colorSwatchLess && swatchContainerData.colorSwatchMore) {
					if ($swatchContainer.hasClass('swatches-expansion-enabled')) {
						$moreBtn.text(swatchContainerData.colorSwatchLess);
					} else {
						$moreBtn.text(swatchContainerData.colorSwatchMore);
					}
				}
				// Adds margin-top to "see more" button to avoid swatches container from overlap it
				$('.load-more-btn-js').css('marginTop', $swatchContainer.height() / 2);
				$.pubsub('publish', 'PLP.SWATCH.TOGGLE_MORE', { container: $swatchContainer });
			}

		_isHoverStateOn = false;
    }

	/* This function calculates the maximum number of swatches that can be displayed on one
	*  row on the product block */
	function _calcMaxSwatches ($swatchContainer){
		var swatchContainerWidth = $swatchContainer.innerWidth(),
				// Change swatch width verification approach based on config
				swatchWidth = $swatchContainer.find('.swatch-js').eq(0).outerWidth(includeFullWidthSwatchSizeCalculation);

		return Math.floor(swatchContainerWidth / swatchWidth);
	}

	/* This function adds a product-n class to each product tile on product lanes.
	 * This is done so that different visibility rules can be applied to each tile.*/
	function _setClassOnProductTileLanes($productTiles){
		$productTiles.each(function (i){
			var n = i + 1;
			$(this).addClass('product-' + n);
		});
	}

	//This function is used for initializing the product block hover behavior
	function initHoverOnProductBlock(){
		var $productBlocks = $('.product-block-js');

		var $productDetailLink = $productBlocks.find('.pdp-url-js');
		var $quickViewButtons = $productBlocks.find('.quickshop-js');

		$productDetailLink.on('mousedown', function (event) {
			event.preventDefault();
		});
		$productDetailLink.on('focus', function (event) {
			var $parentBlock = $(event.target).closest('.product-block-js');
			$parentBlock.find('.quickshop-js').addClass('focused').focus();
		});

		$quickViewButtons.on('focusout', function (event) {
			var $quickViewButton = $(event.target);
			$quickViewButton.removeClass('focused');
		});

		// when enabled multiple more swatch can we viewed on grid page as compared to one.
		if (swatchesExpansionEnabled){
			$productBlocks.hover (
					function (){
						if (!_isHoverStateOn){
							var isExpanded = $('.color-swatches-js').hasClass('swatches-expansion-enabled');
							// Make sure we only remove the 'show-more' class if swatches are not expanded
							if(!isExpanded){
								$('.color-swatches-js').removeClass('show-more');
							}
						}
				});
		}
		$productBlocks.find('.swatch-js').parent().hover (
				function (){
					_isHoverStateOn = true;
				},
				function (){
					_isHoverStateOn = false;
				});

		// Initiates same hover module for mobile devices
		initProductBlockRolloverFunctionality($productBlocks);
	}

	//This function is used for initializing the the rollover functionality for the product block
	function initProductBlockRolloverFunctionality($productBlocks){
		if (!$productBlocks) {
			$productBlocks = $('.product-block-js');
		}
		require(['wcs.rollover-alt-view'], function () {
			if(screenSize.size() !== 'large') {
				$productBlocks.RolloverAltView({ device: 'mobile' });
			}
		});
	}

	//Toggles the text field of target with the data-alt-text
	function toggleText ($target){
    var altText = $target.data('alt-text');
		$target.data('alt-text', $target.text()).text(altText);
		$target.toggleClass('expanded');
	}

	function getS7PresetWithScreenSize(numberOfColumn) {
		var col = numberOfColumn || _currentColumn;
		var s7PresetToUse = _s7Presets.MAIN_VIEW_SMALL_1_COL;

		switch (col) {
			case 2:
				s7PresetToUse = (screenSize.size() == 'small') ? _s7Presets.MAIN_VIEW_SMALL_2_COL : _s7Presets.MAIN_VIEW_LARGE_2_COL;
				break;
			case 4:
				s7PresetToUse = _s7Presets.MAIN_VIEW_LARGE_4_COL;
				break;
			case 6:
				s7PresetToUse = _s7Presets.MAIN_VIEW_LARGE_6_COL;
				break;
			default:
				s7PresetToUse = _s7Presets.MAIN_VIEW_SMALL_1_COL;
		}
		// Remove special character such as $ or &
		return s7PresetToUse.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
	}

	function getNewImgUrlWithPreset(url, s7Preset) {
		var profile = '$$' + s7Preset + '$$';
		// Replace content the old profile with new profile
		// image?$old-profile$ =>  image?$new-profile$
		return url.replace(RegExp("\\$[^\\$]*\\$", 'g'), profile);
	}

	function updateImgWithS7Preset ($item, s7Preset) {
		var $srcAttr = $item.attr('src'),
			hasSrcAttr = (((typeof $srcAttr !== typeof undefined  && $srcAttr !== false) || $srcAttr === "" ) ? true : false); // for i.e. fix
		var url = getNewImgUrlWithPreset($item.attr('srcset'), s7Preset);

		$item.attr('srcset', url);
		$item.attr('data-s7-profile', s7Preset);
		if(hasSrcAttr) {
			$item.attr('src', url);
		}

		return $item;
	}

	function updateProductImgOnGridSwitching(data) {
		var curLayoutCol = (data  && data.columnsPerRow) ? data.columnsPerRow : 4;
		//Only update img on switch more number of columns to less number of column
		if(curLayoutCol < _currentColumn) {
			//Get the preset to use
			_currentColumn = curLayoutCol;
			_s7PresetToUse = getS7PresetWithScreenSize(curLayoutCol);

			var productMainImgList = $('.product-block-views-selected-view-main-image');
			if(productMainImgList.length > 0) {
				productMainImgList.each(function () {
					var $item = $(this);
					$item = updateImgWithS7Preset($item, _s7PresetToUse);
				});
			}
		}
	}

	//Subscribe to events
	function _subscribeEvents() {
		$.pubsub('subscribe', 'vfdp.wcs.product_list.VIEW_LAYOUT_UPDATED', function (msg, event) {
			initMoreSwatches(event.layout);
			if(_isGridLayoutImagePresetsEnabled) {
				updateProductImgOnGridSwitching(event.layout);
			}
		});
	}

	/* =======================================================================================

		Initialize components
	======================================================================================= */
	function initialize(){
		//Add divider if banner is not present
		if ($('.cat-lanes-js').find('.page-banner').length < 1){
			$('.nav-sub-category-js').before('<hr class="cat-nav-bar-divider"></hr>');
		}

		//Initialize width for cat entries on cat nav bar.
		 _calcNavEntryWidthOnBar();

		//Initialize swatch counter for product block
		 initMoreSwatches();

		//Subscribe to events
		_subscribeEvents();

		//update badge position if inlineQuickView is enabled and swatches are in new position
		var isInlineQuickViewOnProductBlock = (productGridCommonInlineQuickviewDesktopEnabled && ( screenSize.size() != 'small' && screenSize.size() != 'medium') ) || (productGridCommonInlineQuickviewMobileEnabled && ( screenSize.size() == 'small' || screenSize.size() == 'medium') );
		if (isInlineQuickViewOnProductBlock) {
			updateBadgePosition();
		}

		//Set class product-n for each product on each lane
		$('body.lane, body.group').not('.no-lanes').find('.product-lane-js').each(function(){
			_setClassOnProductTileLanes($(this).find('.product-block-js'));
		});

		//Initialize docking filter bar scroll handler.
		_toggleDockingBehavior();

		//Initialize hover on product block
		initHoverOnProductBlock();

		//Adjust width for drop down facets on load.
		_adjustDropDownFacetsWidth ();
		_relocateAppliedFacetsOnMobile();

		// Update Img With Presets for Grid Switching
		if(_isGridLayoutImagePresetsEnabled) {
			updateProductImgOnGridSwitching(currentLayout);
		}

		$(window).on({
			click: function (event){
				var $this = $(event.target);
				if (!$this.hasClass ('dd-select-btn-js') && !$this.parent().hasClass ('dd-select-btn-js')){
					_collapsedExpandedCustomDropDowns (true);
				}
				if ($this.data('alt-text')){
					toggleText ($this);
				}
			},
			resize: function (event){
				_onResizeAdjustSelectedDropDownArrow ();
				_adjustDropDownFacetsWidth ();
				_relocateAppliedFacetsOnMobile ();
				_calcNavEntryWidthOnBar();
				initHoverOnProductBlock();
				initMoreSwatches();
			},
			scroll: function(event) {
				Utils.waitForFinalEvent(function(){
					$.pubsub('publish', 'vfdp.wcs.product_list.WINDOW_SCROLL_ENDED');
				}, 500, "Window On Scroll");
			}
		});
		if (WCS_CONFIG.grid.productGridEnablePerformanceMarks) {
			performance.mark("Product Grid View Ready");
		}
	}

	return {
		initialize: initialize,
		toggleFacets: toggleFacets,
		updateVariationId: updateVariationId,
		toggleMoreSwatches: toggleMoreSwatches,
		updateProductBlock: updateProductBlock,
		updateProductBlockImg: updateProductBlockImg,
		updateQuickViewURL: updateQuickViewURL,
		updateProductBlockPrice: updateProductBlockPrice,
		toggleCustomDropDown: toggleCustomDropDown,
		initHoverOnProductBlock: initHoverOnProductBlock,
		initMoreSwatches: initMoreSwatches,
		updateDiscountPercentage: updateDiscountPercentage,
		getS7PresetWithScreenSize: getS7PresetWithScreenSize,
		updateImgWithS7Preset: updateImgWithS7Preset,
		getNewImgUrlWithPreset: getNewImgUrlWithPreset,
		initProductBlockRolloverFunctionality: initProductBlockRolloverFunctionality
	};

});
